import { createApi } from "@reduxjs/toolkit/query/react"
import { default as customBaseQuery } from "./api.baseQuery"

export const api = createApi({
  baseQuery: customBaseQuery,
  tagTypes: [],
  endpoints: () => ({}),
})
